import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GroupsService } from '../../../services/groups.service';

@Component({
  selector: 'app-group-create',
  templateUrl: './group-create.component.html',
  styleUrls: ['./group-create.component.css']
})
export class GroupCreateComponent implements OnInit {
  groupForm!: FormGroup;
  loading = false;
  currentUser: string = '';

  constructor(
    private fb: FormBuilder,
    private groupsService: GroupsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.getCurrentUser();
  }

  /**
   * Inicializa o formulário reativo
   */
  initializeForm(): void {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      description: ['', [Validators.maxLength(500)]]
    });
  }

  /**
   * Obtém o usuário atual do localStorage
   */
  getCurrentUser(): void {
    // Tenta obter o email do usuário logado de diferentes fontes
    const lastLoggedEmail = localStorage.getItem('lastLoggedEmail');
    
    if (lastLoggedEmail) {
      this.currentUser = lastLoggedEmail;
      return;
    }

    // Fallback: tenta obter do currentUser
    const currentUserJson = localStorage.getItem('currentUser');
    if (currentUserJson) {
      try {
        const user = JSON.parse(currentUserJson);
        this.currentUser = user.email || '';
        
      } catch (error) {
        console.error('Erro ao obter usuário:', error);
        this.currentUser = '';
      }
    } else {
      this.currentUser = '';
    }
  }

  /**
   * Verifica se um campo tem erro
   */
  hasError(fieldName: string, errorType: string): boolean {
    const field = this.groupForm.get(fieldName);
    return !!(field && field.hasError(errorType) && (field.dirty || field.touched));
  }

  /**
   * Salva o grupo
   */
  async onSubmit(): Promise<void> {
    // Marca todos os campos como touched para exibir erros
    this.groupForm.markAllAsTouched();
    
    if (this.groupForm.invalid) {
      alert('Formulário inválido: Por favor, corrija os erros antes de continuar.');
      return;
    }

    // Valida se o email do usuário está disponível
    if (!this.currentUser || this.currentUser.trim() === '') {
      alert('Erro: Email do usuário não encontrado. Por favor, faça login novamente.');
      return;
    }

    this.loading = true;

    const formValue = this.groupForm.value;
    
    try {
      // Cria grupo simples
      const groupData = {
        name: formValue.name.trim(),
        description: formValue.description?.trim() || '',
        createdBy: this.currentUser
      };

      await this.groupsService.createGroup(groupData).toPromise();

      alert('Sucesso! Grupo criado com sucesso.');
      this.router.navigate(['/admin/groups']);
    } catch (error: any) {
      console.error('Erro ao criar grupo:', error);
      
      let errorMessage = 'Ocorreu um erro ao criar o grupo.';
      
      if (error.error?.message) {
        errorMessage = error.error.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      alert('Erro ao criar grupo: ' + errorMessage);
    } finally {
      this.loading = false;
    }
  }

  /**
   * Cancela e volta para a listagem
   */
  onCancel(): void {
    if (this.groupForm.dirty) {
      if (confirm('Cancelar criação? Existem alterações não salvas. Deseja realmente cancelar?')) {
        this.router.navigate(['/admin/groups']);
      }
    } else {
      this.router.navigate(['/admin/groups']);
    }
  }

  /**
   * Obtém a mensagem de erro para um campo
   */
  getErrorMessage(fieldName: string): string {
    const field = this.groupForm.get(fieldName);
    
    if (field?.hasError('required')) {
      return 'Este campo é obrigatório.';
    }
    
    if (field?.hasError('minlength')) {
      const minLength = field.errors?.['minlength'].requiredLength;
      return `Mínimo de ${minLength} caracteres.`;
    }
    
    if (field?.hasError('maxlength')) {
      const maxLength = field.errors?.['maxlength'].requiredLength;
      return `Máximo de ${maxLength} caracteres.`;
    }
    
    return '';
  }
}
